export default () => ({
  title: {
    style: {
      display: 'block',
    },
    align: 'center',
    verticalAlign: 'middle',
  },
});
